import { useTranslations } from "@/lib/static-intl";

const PostCmtStickyTag = () => {
  const explorePostDetailsT = useTranslations("explore.explore_post_details");

  return (
    <span className="w-fit text-center text-xs text-[rgb(255,36,36)] bg-rose-50 px-2 py-1 rounded-xl leading-6 font-medium">
      {explorePostDetailsT("sticky_comment")}
    </span>
  );
};

export default PostCmtStickyTag;
